import {connect} from "react-redux";
import DockList from "./DockList";
import {dockListDeliveriesHandlers, dockListDeliveriesProps} from "../common-comps/dock";
import {getComputedDockListShipping} from "../../selectors/dock";
import {withRouter} from "react-router-dom";

const mapState = (state) => dockListDeliveriesProps(state, getComputedDockListShipping(state));
;

export const DockListShipping = withRouter(connect(
  mapState,
  (dispatch) => dockListDeliveriesHandlers(dispatch)
)(DockList));

export default DockListShipping;
